module.exports = __webpack_public_path__ + "static/img/haneari_rui.23012bf.jpg";